
import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreateElement } from 'vue';

@Component
export default class SListRow extends Vue {
  @Prop({ type: String, default: '' }) private cssClass!: string;
  @Prop({ type: Boolean, default: false }) private vertical!: boolean;

  private get css(): string {
    return `list-row ${this.vertical ? 'vertical' : ''} ${this.cssClass}`.trim();
  }

  private render(createElement: CreateElement) {
    return createElement('div', { class: this.css }, this.$slots.default);
  }
}
